import { APIResponse, Events } from "../../../@types";
const URL = import.meta.env.VITE_API_URL;

type Updates = Record<string, { tribes: number[]; castaways: number[] }>;

export async function updateEpisodeEvents(episodeId: number, updates: Updates) {
  const requestOptions: RequestInit = {
    method: "POST",
    redirect: "follow",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
    },
    body: JSON.stringify({ updates, episodeId }),
  };

  await fetch(URL + `/admin/events/update`, requestOptions);
}
